import {ItemFactory} from "@connox/typescript-library";
import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import ExploreRelatedSeries from "./ExploreRelatedSeries";

declare const c_ActiveCurrency: string;

export class ProductSeriesHandler {
  public static async run(parentCategoriesElement: HTMLElement) {
    const categoryId: number = Number(parentCategoriesElement.dataset.parentCategoryId);
    const parentName: string = String(parentCategoriesElement.dataset.name);
    const url: string = String(parentCategoriesElement.dataset.categoryUrl);
    const currencyCode: string = c_ActiveCurrency;
    const channelId: number = Number(document.body.dataset.channel);
    const limit: number = Number(parentCategoriesElement.dataset.limit);

    const response = await ItemFactory.getItems(channelId, {currencyCode, categoryId, limit});
    if (response.itemContent.length > 0) {
      ReactDOM.render(
        React.createElement(
          Suspense,
          {fallback: null},
          React.createElement(
            ExploreRelatedSeries,
            {
              name: parentName,
              products: response.itemContent,
              url,
            },
            null,
          ),
        ),
        parentCategoriesElement,
      );
    }
  }
}
